import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import DirectoryPage from './components/DirectoryPage';
import ServicesPage from './components/ServicesPage';
import NewsPage from './components/NewsPage';
import EventsPage from './components/EventsPage';
import GalleryPage from './components/GalleryPage';
import AgriculturePage from './components/AgriculturePage';
import GrievancePage from './components/GrievancePage';
import AdminPage from './components/AdminPage';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App min-h-screen flex flex-col">
          <Routes>
            {/* Admin route without header/footer */}
            <Route path="/admin" element={<AdminPage />} />
            
            {/* Public routes with header/footer */}
            <Route path="*" element={
              <>
                <Header />
                <main className="flex-1">
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/directory" element={<DirectoryPage />} />
                    <Route path="/services" element={<ServicesPage />} />
                    <Route path="/news" element={<NewsPage />} />
                    <Route path="/events" element={<EventsPage />} />
                    <Route path="/gallery" element={<GalleryPage />} />
                    <Route path="/agriculture" element={<AgriculturePage />} />
                    <Route path="/grievance" element={<GrievancePage />} />
                  </Routes>
                </main>
                <Footer />
              </>
            } />
          </Routes>
          <Toaster position="top-center" richColors />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
